import { lazy, Suspense, type ComponentProps } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
// Type-only: the Monaco module itself is loaded by the `lazy` import below.
import type { WebsiteBannerMonacoEditor } from '@/components/website-banner-monaco-editor';

const MonacoEditor = lazy(() =>
  import('@/components/website-banner-monaco-editor').then((module) => ({
    default: module.WebsiteBannerMonacoEditor,
  }))
);

/** Monaco in its own chunk, only fetched when mounted (AD-030: desktop only). */
export function LazyMonaco(
  props: ComponentProps<typeof WebsiteBannerMonacoEditor>
) {
  return (
    <Suspense fallback={<Skeleton className="h-[100px] w-full" />}>
      <MonacoEditor {...props} />
    </Suspense>
  );
}
